module.exports = __webpack_public_path__ + "static/media/copy_icon.e4b31f79.svg";